/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTheme, IconButton } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import { ICustomTheme } from 'interfaces';

interface ITablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}

export default function TablePaginationActions({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: ITablePaginationActionsProps): JSX.Element {
  const theme: ICustomTheme = useTheme();

  function handleBackButtonClick(
    event: React.MouseEvent<HTMLButtonElement>,
  ): void {
    onPageChange(event, page - 1);
  }

  function handleNextButtonClick(
    event: React.MouseEvent<HTMLButtonElement>,
  ): void {
    onPageChange(event, page + 1);
  }

  return (
    <div css={{ flexShrink: 0, marginLeft: theme.spacing(2) }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft fontSize="large" />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight fontSize="large" />
      </IconButton>
    </div>
  );
}
